import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import e$1, { createContext, Component, createElement, useState, useMemo, useContext, useCallback, useEffect, Fragment as Fragment$1 } from 'react';
import { Count, VisuallyHidden, Typography, Visible, Link, FlexBox, ScreenClassProvider } from '@vp/swan';

const ErrorBoundaryContext = createContext(null);

const initialState = {
  didCatch: false,
  error: null
};
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
    this.state = initialState;
  }
  static getDerivedStateFromError(error) {
    return {
      didCatch: true,
      error
    };
  }
  resetErrorBoundary() {
    const {
      error
    } = this.state;
    if (error !== null) {
      var _this$props$onReset, _this$props;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === void 0 ? void 0 : _this$props$onReset.call(_this$props, {
        args,
        reason: "imperative-api"
      });
      this.setState(initialState);
    }
  }
  componentDidCatch(error, info) {
    var _this$props$onError, _this$props2;
    (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 ? void 0 : _this$props$onError.call(_this$props2, error, info);
  }
  componentDidUpdate(prevProps, prevState) {
    const {
      didCatch
    } = this.state;
    const {
      resetKeys
    } = this.props;

    // There's an edge case where if the thing that triggered the error happens to *also* be in the resetKeys array,
    // we'd end up resetting the error boundary immediately.
    // This would likely trigger a second error to be thrown.
    // So we make sure that we don't check the resetKeys on the first call of cDU after the error is set.

    if (didCatch && prevState.error !== null && hasArrayChanged(prevProps.resetKeys, resetKeys)) {
      var _this$props$onReset2, _this$props3;
      (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 ? void 0 : _this$props$onReset2.call(_this$props3, {
        next: resetKeys,
        prev: prevProps.resetKeys,
        reason: "keys"
      });
      this.setState(initialState);
    }
  }
  render() {
    const {
      children,
      fallbackRender,
      FallbackComponent,
      fallback
    } = this.props;
    const {
      didCatch,
      error
    } = this.state;
    let childToRender = children;
    if (didCatch) {
      const props = {
        error,
        resetErrorBoundary: this.resetErrorBoundary
      };
      if (typeof fallbackRender === "function") {
        childToRender = fallbackRender(props);
      } else if (FallbackComponent) {
        childToRender = createElement(FallbackComponent, props);
      } else if (fallback !== undefined) {
        childToRender = fallback;
      } else {
        throw error;
      }
    }
    return createElement(ErrorBoundaryContext.Provider, {
      value: {
        didCatch,
        error,
        resetErrorBoundary: this.resetErrorBoundary
      }
    }, childToRender);
  }
}
function hasArrayChanged() {
  let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return a.length !== b.length || a.some((item, index) => !Object.is(item, b[index]));
}

var s$1="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{};function c$1(e){return e&&e.__esModule&&Object.prototype.hasOwnProperty.call(e,"default")?e.default:e}var u$1,p,g,f={exports:{}};p=s$1,g=function(){var e=function(){},o="undefined",t=typeof window!==o&&typeof window.navigator!==o&&/Trident\/|MSIE /.test(window.navigator.userAgent),n=["trace","debug","info","warn","error"],r={},i=null;function l(e,o){var t=e[o];if("function"==typeof t.bind)return t.bind(e);try{return Function.prototype.bind.call(t,e)}catch(o){return function(){return Function.prototype.apply.apply(t,[e,arguments])}}}function a(){console.log&&(console.log.apply?console.log.apply(console,arguments):Function.prototype.apply.apply(console.log,[console,arguments])),console.trace&&console.trace();}function s(){for(var t=this.getLevel(),r=0;r<n.length;r++){var i=n[r];this[i]=r<t?e:this.methodFactory(i,t,this.name);}if(this.log=this.debug,typeof console===o&&t<this.levels.SILENT)return "No console available for logging"}function c(e){return function(){typeof console!==o&&(s.call(this),this[e].apply(this,arguments));}}function u(n,r,i){return function(n){return "debug"===n&&(n="log"),typeof console!==o&&("trace"===n&&t?a:void 0!==console[n]?l(console,n):void 0!==console.log?l(console,"log"):e)}(n)||c.apply(this,arguments)}function p(e,t){var l,a,c,p=this,g="loglevel";function f(){var e;if(typeof window!==o&&g){try{e=window.localStorage[g];}catch(e){}if(typeof e===o)try{var t=window.document.cookie,n=encodeURIComponent(g),r=t.indexOf(n+"=");-1!==r&&(e=/^([^;]+)/.exec(t.slice(r+n.length+1))[1]);}catch(e){}return void 0===p.levels[e]&&(e=void 0),e}}function d(e){var o=e;if("string"==typeof o&&void 0!==p.levels[o.toUpperCase()]&&(o=p.levels[o.toUpperCase()]),"number"==typeof o&&o>=0&&o<=p.levels.SILENT)return o;throw new TypeError("log.setLevel() called with invalid level: "+e)}"string"==typeof e?g+=":"+e:"symbol"==typeof e&&(g=void 0),p.name=e,p.levels={TRACE:0,DEBUG:1,INFO:2,WARN:3,ERROR:4,SILENT:5},p.methodFactory=t||u,p.getLevel=function(){return null!=c?c:null!=a?a:l},p.setLevel=function(e,t){return c=d(e),!1!==t&&function(e){var t=(n[e]||"silent").toUpperCase();if(typeof window!==o&&g){try{return void(window.localStorage[g]=t)}catch(e){}try{window.document.cookie=encodeURIComponent(g)+"="+t+";";}catch(e){}}}(c),s.call(p)},p.setDefaultLevel=function(e){a=d(e),f()||p.setLevel(e,!1);},p.resetLevel=function(){c=null,function(){if(typeof window!==o&&g){try{window.localStorage.removeItem(g);}catch(e){}try{window.document.cookie=encodeURIComponent(g)+"=; expires=Thu, 01 Jan 1970 00:00:00 UTC";}catch(e){}}}(),s.call(p);},p.enableAll=function(e){p.setLevel(p.levels.TRACE,e);},p.disableAll=function(e){p.setLevel(p.levels.SILENT,e);},p.rebuild=function(){if(i!==p&&(l=d(i.getLevel())),s.call(p),i===p)for(var e in r)r[e].rebuild();},l=d(i?i.getLevel():"WARN");var v=f();null!=v&&(c=d(v)),s.call(p);}(i=new p).getLogger=function(e){if("symbol"!=typeof e&&"string"!=typeof e||""===e)throw new TypeError("You must supply a name when creating a logger.");var o=r[e];return o||(o=r[e]=new p(e,i.methodFactory)),o};var g=typeof window!==o?window.log:void 0;return i.noConflict=function(){return typeof window!==o&&window.log===i&&(window.log=g),i},i.getLoggers=function(){return r},i.default=i,i},(u$1=f).exports?u$1.exports=g():p.log=g();var d=c$1(f.exports);const v="SILENT";let y=null;const w=({level:e=""}={})=>{if(y)return y.warn("Logger Already Initialized!"),y;const o=(e=>{if(null==e||""===e)return !1;let o=!1;if("number"==typeof e)e>=0&&e<=5&&(o=!0);else if("string"==typeof e){const t=e.toUpperCase();Object.keys(d.levels).forEach(e=>{t===e&&(o=!0);});}return o})(e);o||console.error("Invalid logging level provided, returning a silent logger. There will be no console output.");const t=o?e:d.levels.SILENT,n=d.getLogger("om-translations-logger");return n.setLevel(t,!1),y=n,y.trace("Initialized Logger with level:",e),y},h=()=>(y||w({level:v}),y),L=createContext({activeTranslationDictionary:{},targetLocale:"",setLocale:()=>{}}),m=({children:o,translationResources:r,locale:i="",logLevel:a=v})=>{const s=e$1.useMemo(()=>w({level:a}),[a]),[c,u]=useState(i);e$1.useEffect(()=>{i&&u(i.toLowerCase());},[i]);const p=r,g=useMemo(()=>({activeTranslationDictionary:p[c.toLowerCase()]||{},targetLocale:c,setLocale:u}),[p,c]);return s.trace(`[LocalizationProvider] Rendering with locale: ${c}`,r,g.activeTranslationDictionary),jsx(L.Provider,Object.assign({value:g},{children:o}))},T=()=>{const{activeTranslationDictionary:e}=useContext(L);return {localizationLookUpFunction:useCallback((o,t)=>{if(!!!e[o])return {hasAllCopy:!1,copiesMissing:["Translation group not found"]};const n=t.filter(t=>!Object.keys(e[o]).includes(t));return {hasAllCopy:0===n.length,copiesMissing:n}},[e])}},b=({translationGroup:e,targetLocale:o,activeTranslationGroup:t={},logger:n})=>new Proxy(t,{get:(r,i)=>{if(Object.prototype.hasOwnProperty.call(t,i)){const o=t[i];return "string"==typeof o?o:"object"==typeof o&&o.value&&"string"==typeof o.value?o.value:(n.error(`${i} is invalid in translation group: ${e}`),`[${e}.${i}]`)}return n.warn(`${i} does not exist in translation group: ${e} in targetLocale: ${o}.`),`[${e}.${i}]`}}),k=e=>{const{activeTranslationDictionary:o,targetLocale:t}=useContext(L),n=h(),{localizationLookUpFunction:i}=T();return e.map(e=>o[e]?b({translationGroup:e,activeTranslationGroup:o[e],targetLocale:t,logger:n}):(({missingTranslationGroup:e,targetLocale:o,logger:t})=>(t.warn(`No Translation Group: ${e} in ${o}.`),b({translationGroup:e,targetLocale:o,logger:t})))({missingTranslationGroup:e,targetLocale:t,logger:n})).concat([i])};

const INTERNAL_CLAIM = 'https://claims.cimpress.io/cimpress_internal';
const deriveShopperContext = (authLibrary) => {
    var _a, _b;
    // if the authenticated user is internal, return empty canonical ID and header
    // vistacart cannot retrieve a cart for their canonical ID so it should not try
    if (((_b = (_a = authLibrary === null || authLibrary === void 0 ? void 0 : authLibrary.getProfile) === null || _a === void 0 ? void 0 : _a.call(authLibrary)) === null || _b === void 0 ? void 0 : _b[INTERNAL_CLAIM]) === true) {
        return { canonicalId: '', authHeader: '', isSignedIn: true };
    }
    try {
        return {
            canonicalId: authLibrary.getCanonicalId(),
            authHeader: typeof authLibrary.getAuthorizationHeader !== 'undefined'
                ? authLibrary.getAuthorizationHeader()
                : `Bearer ${authLibrary.getToken()}`,
            isSignedIn: authLibrary.isSignedIn(),
        };
    }
    catch (_error) {
        console.warn('[@vp/cart-client] Invalid Auth Library passed to component.');
        return { canonicalId: '', authHeader: '', isSignedIn: false };
    }
};

const SessionContext = createContext(undefined);
const SessionContextProvider = ({ children, locale, tenantDetails, auth, }) => {
    const { canonicalId, authHeader, isSignedIn } = deriveShopperContext(auth);
    const sessionContextValues = useMemo(() => ({
        locale,
        tenantDetails,
        shopperId: canonicalId,
        shopperToken: authHeader,
        isSignedIn,
        auth,
    }), [locale, tenantDetails, canonicalId, authHeader, auth, isSignedIn]);
    return (jsx(SessionContext.Provider, Object.assign({ value: sessionContextValues }, { children: children })));
};
function useSessionContext() {
    const context = useContext(SessionContext);
    if (context === undefined) {
        throw new Error('useSessionContext must be used within a SessionContextProvider');
    }
    return context;
}

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */


function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function e(e,t,r,s){return new(r||(r=Promise))((function(n,o){function i(e){try{c(s.next(e));}catch(e){o(e);}}function u(e){try{c(s.throw(e));}catch(e){o(e);}}function c(e){var t;e.done?n(e.value):(t=e.value,t instanceof r?t:new r((function(e){e(t);}))).then(i,u);}c((s=s.apply(e,t||[])).next());}))}"function"==typeof SuppressedError&&SuppressedError;class t extends Error{constructor(e){super(e),this.rootStack="",this.response=void 0,this.request=void 0,this.config={},this.isRetryable=!1,Object.setPrototypeOf(this,t.prototype);}}const r=/[/?#]/,s=/timeout/,n="UNKNOWN",o=e=>{if(!e||"string"!=typeof e)return "";const t=e.replace("http://","").replace("https://","").split(r);return t&&t.length>0?t[0]:n};class i{constructor(){this.handlers=[];}use(e,t){this.handlers.push([e,t]);}get(){return this.handlers}}function u(t){const{url:r,timeout:s=null,maxAttempts:n=1}=t,o=function(e,t){var r={};for(var s in e)Object.prototype.hasOwnProperty.call(e,s)&&t.indexOf(s)<0&&(r[s]=e[s]);if(null!=e&&"function"==typeof Object.getOwnPropertySymbols){var n=0;for(s=Object.getOwnPropertySymbols(e);n<s.length;n++)t.indexOf(s[n])<0&&Object.prototype.propertyIsEnumerable.call(e,s[n])&&(r[s[n]]=e[s[n]]);}return r}(t,["url","timeout","maxAttempts"]),i=u.requestInterceptors.get().reverse(),c=u.responseInterceptors.get();let l=Promise.resolve(o);const p=[...i,[t=>e(this,void 0,void 0,(function*(){let e,o,i=0;do{let n;try{let i;if(s){const e=new AbortController;i=e.signal,n=setTimeout((()=>e.abort("fetch timeout hit, aborting")),s);}const{params:u}=t,c=new URLSearchParams(Object.assign({},u)),l=[...c].length>0;o=new Request([r,l&&c].filter(Boolean).join("?"),Object.assign(Object.assign({},t),{signal:i}));e={response:yield fetch(o),request:o};}catch(t){e={error:{message:t,request:o}};}finally{n&&clearTimeout(n);}i+=1;}while(i<n&&(!("response"in e)||!e.response.ok));return "response"in e?{request:e.request,response:e.response}:Promise.reject(e.error)})),void 0],...c];for(;p.length;){const[e,t]=p.shift();l=l.then(e,t);}return l}u.requestInterceptors=new i,u.responseInterceptors=new i;const c=(e,r,i)=>{if(r){const s=(null==r?void 0:r.status)||n,i=(null==e?void 0:e.method)||n,u=(null==r?void 0:r.url)||(null==e?void 0:e.url)||"",c=o(u),l=new t(`[FETCH][STATUSCODE=${s}][METHOD=${i}][DOMAIN=${c}]`);return l.response=r,l.request=e,l.isRetryable="number"==typeof s&&(s>499&&s<600),l}if(e){const r=e.url||"",u=o(r),c=e.method||n;let l;return s.test(i.message)?(l=new t(`[FETCH][TIMEOUT][METHOD=${c}][DOMAIN=${u}]`),l.isRetryable=!0):l=new t(`[FETCH][REQUEST FAILED][METHOD=${c}][DOMAIN=${u}]`),l.rootStack=null==i?void 0:i.stack,l.request=null==i?void 0:i.request,l}return i};u.requestInterceptors.use((e=>e)),u.responseInterceptors.use((e=>{const{request:t,response:r}=e;return r.ok?r:Promise.reject(c(t,r))}),(e=>{const{request:t}=e;return Promise.reject(c(t,void 0,e))}));const l=e=>({Authorization:e});

const CART_ITEM_COUNT_CACHE = 'cart-item-count-cache';
// in-memory cache object for /cartSummary endpoint
let inMemoryCache = {};
const getCacheKey = (tenant, shopperId, cache) => `${tenant}-${shopperId}-${cache}`;
const getCachedJson = (cacheKey) => {
    const cachedItem = inMemoryCache[cacheKey];
    if (cachedItem) {
        return cachedItem;
    }
    return undefined;
};
function clearCartClientCache() {
    inMemoryCache = {};
}
/**
 * Calling /cartSummary endpoint that gives cart item count
 */
const getCartSummary = ({ tenant, shopperId, authToken, pageName, }) => __awaiter(void 0, void 0, void 0, function* () {
    // if we have cached value return it.
    const cacheKey = getCacheKey(tenant, shopperId, CART_ITEM_COUNT_CACHE);
    const cacheJson = yield getCachedJson(cacheKey);
    if (cacheJson) {
        return cacheJson;
    }
    // otherwise, fetch cart item count from backend
    const requestor = encodeURIComponent(pageName ? `miniCart-${pageName}` : `miniCart`);
    try {
        const apiResponse = yield u({
            url: `https://minicart.orders.vpsvc.com/tenants/${tenant}/carts/${shopperId}/summary?requestor=${requestor}`,
            headers: l(authToken),
        })
            .then((response) => response.json())
            .then((json) => {
            inMemoryCache[cacheKey] = json;
            return json;
        });
        return apiResponse;
    }
    catch (err) {
        console.error('Error occurs when calling vistacart cartSummary endpoint', err);
        throw err;
    }
});

const UPDATE_CART_EVENT = 'CART_CLIENT_REFRESH';
const invalidateMiniCartData = ({ debug = false }) => {
    clearCartClientCache();
    const refreshEvent = new Event(UPDATE_CART_EVENT);
    if (typeof window !== `undefined`) {
        try {
            window.dispatchEvent(refreshEvent);
        }
        catch (err) {
            if (debug) {
                console.error('[CartClient] error when dispatching `window` event.', err);
            }
        }
    }
    else if (debug) {
        console.error('[CartClient] `window` undefined, unable to issue refresh.');
    }
};

const TrackingContext = createContext(undefined);
const TrackingContextProvider = ({ pageName, pageSection, pageStage, children, }) => {
    const trackingContextValues = useMemo(() => ({
        pageSection,
        pageStage,
        pageName,
    }), [pageName, pageSection, pageStage]);
    return (jsx(TrackingContext.Provider, Object.assign({ value: trackingContextValues }, { children: children })));
};
const useTrackingContext = () => {
    const context = useContext(TrackingContext);
    if (context === undefined) {
        throw new Error('useTrackingContext must be used within a TrackingContextProvider');
    }
    return context;
};

const CartItemCountContext = createContext(undefined);
const CartItemCountProvider = ({ children, }) => {
    const { shopperId, shopperToken, tenantDetails, auth } = useSessionContext();
    const { pageName } = useTrackingContext();
    const [cartSummary, setCartSummary] = useState();
    const [cartItemCountFetchFailed, setCartItemCountFetchFailed] = useState(false);
    useEffect(() => {
        const getCartSummary$1 = () => __awaiter(void 0, void 0, void 0, function* () {
            if (!auth) {
                return;
            }
            try {
                const summary = yield getCartSummary({
                    shopperId,
                    tenant: tenantDetails.tenantId,
                    authToken: shopperToken,
                    pageName,
                });
                setCartSummary(summary);
            }
            catch (_e) {
                setCartItemCountFetchFailed(true);
            }
        });
        if (shopperId && shopperToken && tenantDetails.tenantId) {
            getCartSummary$1();
        }
        // TODO: Test parameter refactor with event.
        window.addEventListener(UPDATE_CART_EVENT, getCartSummary$1);
        return () => {
            window.removeEventListener(UPDATE_CART_EVENT, getCartSummary$1);
        };
    }, [auth, tenantDetails, shopperId, shopperToken, pageName]);
    const countData = useMemo(() => {
        // api call failed
        if (cartItemCountFetchFailed) {
            return { cartItemCountFetchFailed };
        }
        // api call succeeded, set item count to tenants count type
        if (cartSummary && tenantDetails.cartCountType) {
            return {
                cartItemCount: cartSummary[tenantDetails.cartCountType],
            };
        }
        // default count is item count
        return { cartItemCount: cartSummary === null || cartSummary === void 0 ? void 0 : cartSummary.itemCount };
    }, [cartSummary, tenantDetails.cartCountType, cartItemCountFetchFailed]);
    return (jsx(CartItemCountContext.Provider, Object.assign({ value: countData }, { children: children })));
};
function useCartItemCountContext() {
    const context = useContext(CartItemCountContext);
    if (context === undefined) {
        throw new Error('useCartItemCountContext must be used within a CartItemCountContextProvider');
    }
    return context;
}

var cartItemsCountMessages$e = {
	cartItemsCount: "Number of items in basket: ",
	zeroCartItemsCount: "Your basket is empty."
};
var cartLabelMessages$e = {
	cartLabel: "Basket",
	flyoutTitle: "My Basket"
};
var miniCartMessages$e = {
	cartButton: "Go to basket",
	emptyCart: "Basket is empty.",
	signInPrompt: "Already have an account? Sign in to view your selected items.",
	signInButton: "Sign in",
	continueButton: "Continue shopping",
	checkoutButton: "Checkout",
	groupTotal: "Group total",
	yourItems: "Your items",
	pricingSummary: "Pricing summary",
	youSaved: "You saved",
	thisOrder: "This order",
	productSubtotal: "Product subtotal",
	cartLoading: "Preparing the basket...",
	remove: "Remove",
	basePrice: "Base price:",
	edit: "Edit"
};
var errorMessages$e = {
	genericIssuesError: "There are issues with items in your basket.",
	fetchingIssuesError: "We're sorry, an error occurred loading your basket.",
	tryAgainOrContactCare: "Please try again or contact CARE if this problem persists."
};
var templateBillingMessages$e = {
	pricingSummaryPayToday: "This order",
	"itemPriceLabel:annualSubscription": "To pay today",
	"templatePriceLabel:annualSubscription": "Annual subscription",
	"templateSummaryLabel:annualSubscription": "Annual subscriptions",
	"templateSummarySubtotal:annualSubscription": "Annual payment",
	"templatePriceUnit:annualSubscription": "{{{price}}}/yr",
	"itemPriceLabel:monthlySubscription": "To pay today",
	"templatePriceLabel:monthlySubscription": "Monthly subscription",
	"templateSummaryLabel:monthlySubscription": "Monthly subscriptions",
	"templateSummarySubtotal:monthlySubscription": "Monthly payment",
	"templatePriceUnit:monthlySubscription": "{{{price}}}/mo"
};
var a11yLabels$e = {
	close: "Close",
	hide: "Hide",
	show: "Show",
	loading: "Loading..."
};
var couponMessages$e = {
	enterPromoCode: "Enter your code",
	apply: "Apply",
	clear: "Clear",
	promoCodeApplied: "Code applied successfully.",
	offerDetails: "Offer details",
	changeCode: "Change code",
	promotionalCode: "Code: {{{promoCode}}}",
	currentPromo: "Current code:",
	clearPromo: "Clear code",
	updatePromo: "Update code",
	noPromo: "No code applied",
	addPromoPrompt: "Have a code?",
	promoCodeClearFailed: "Could not clear discount code.",
	NotApplicable: "This code doesn’t exist. Please try another one.",
	RequiresMissingCustomerGroup: "This code isn’t valid for your account. Please try another one.",
	Expired: "This code has expired. Please try an active one.",
	NotLiveYet: "This code isn’t active yet. Please try it again later.",
	UnableToValidate: "This code isn’t working. Please try it again later.",
	OncePerShopper: "This code has already been used. Please use another one.",
	ExceedsUsageLimit: "This code has reached its usage limit.",
	RequiresLoggedInShopper: "Sign in to apply this code."
};
var feeMessages$e = {
	postageFee: "Postage",
	mailingServiceFee: "Mailing list service",
	rushProcessingFee: "Rush processing",
	setupFee: "Setup",
	fallbackFee: "Additional fees"
};
var enGB = {
	cartItemsCountMessages: cartItemsCountMessages$e,
	cartLabelMessages: cartLabelMessages$e,
	miniCartMessages: miniCartMessages$e,
	errorMessages: errorMessages$e,
	templateBillingMessages: templateBillingMessages$e,
	a11yLabels: a11yLabels$e,
	couponMessages: couponMessages$e,
	feeMessages: feeMessages$e
};

var cartItemsCountMessages$d = {
	cartItemsCount: "Number of items in cart: ",
	zeroCartItemsCount: "Your cart is empty."
};
var cartLabelMessages$d = {
	cartLabel: "Cart",
	flyoutTitle: "My Cart"
};
var miniCartMessages$d = {
	cartButton: "Add to cart",
	emptyCart: "Your cart is empty.",
	signInPrompt: "Already have an account? Sign in to view your selected items.",
	signInButton: "Sign in",
	continueButton: "Continue Shopping",
	checkoutButton: "Checkout",
	groupTotal: "Group Total",
	yourItems: "Your Items",
	pricingSummary: "Order summary",
	youSaved: "You Saved",
	thisOrder: "This Order",
	productSubtotal: "Products subtotal",
	cartLoading: "Preparing the cart...",
	remove: "Remove",
	basePrice: "Base Price:",
	edit: "Edit"
};
var errorMessages$d = {
	genericIssuesError: "* There are issues with some of the items in your cart *",
	fetchingIssuesError: "An error occurred when loading your cart, please try again.",
	tryAgainOrContactCare: "Please try again or contact CARE if this problem persists."
};
var templateBillingMessages$d = {
	pricingSummaryPayToday: "This Order",
	"itemPriceLabel:annualSubscription": "To Pay Today",
	"templatePriceLabel:annualSubscription": "Annual Subscription",
	"templateSummaryLabel:annualSubscription": "Annual Subscriptions",
	"templateSummarySubtotal:annualSubscription": "Annual Payment",
	"templatePriceUnit:annualSubscription": "{{{price}}}/yr",
	"itemPriceLabel:monthlySubscription": "To Pay Today",
	"templatePriceLabel:monthlySubscription": "Monthly Subscription",
	"templateSummaryLabel:monthlySubscription": "Monthly Subscriptions",
	"templateSummarySubtotal:monthlySubscription": "Monthly Payment",
	"templatePriceUnit:monthlySubscription": "{{{price}}}/mo"
};
var a11yLabels$d = {
	close: "Close",
	hide: "Hide",
	show: "Show",
	loading: "Loading..."
};
var couponMessages$d = {
	enterPromoCode: "Enter your code",
	apply: "Apply",
	clear: "Clear",
	promoCodeApplied: "Code applied successfully.",
	offerDetails: "Offer details",
	changeCode: "Change code",
	promotionalCode: "Code: {{{promoCode}}}",
	currentPromo: "Current code:",
	clearPromo: "Clear code",
	updatePromo: "Update code",
	noPromo: "No Promo Code Applied",
	addPromoPrompt: "Have a code?",
	promoCodeClearFailed: "Could not clear discount code.",
	NotApplicable: "This promo code doesn’t exist. Please try another file.",
	RequiresMissingCustomerGroup: "This promo code isn’t valid for your account. Please try another file.",
	Expired: "This code has expired. Please try an active one.",
	NotLiveYet: "This promo code isn’t active yet. Please try again later.",
	UnableToValidate: "This promo code isn’t working. Please try again later.",
	OncePerShopper: "This promo code has already been used. Please use another one.",
	ExceedsUsageLimit: "This code has reached the limit of times it can be used.",
	RequiresLoggedInShopper: "Sign in to apply this code."
};
var feeMessages$d = {
	postageFee: "Postage",
	mailingServiceFee: "Mailing List service",
	rushProcessingFee: "Rush processing",
	setupFee: "Setup",
	fallbackFee: "Additional fees"
};
var enAU = {
	cartItemsCountMessages: cartItemsCountMessages$d,
	cartLabelMessages: cartLabelMessages$d,
	miniCartMessages: miniCartMessages$d,
	errorMessages: errorMessages$d,
	templateBillingMessages: templateBillingMessages$d,
	a11yLabels: a11yLabels$d,
	couponMessages: couponMessages$d,
	feeMessages: feeMessages$d
};

var cartItemsCountMessages$c = {
	cartItemsCount: "Número de artigos no seu cesto: ",
	zeroCartItemsCount: "O seu cesto encontra-se vazio."
};
var cartLabelMessages$c = {
	cartLabel: "Cesto",
	flyoutTitle: "O meu cesto"
};
var miniCartMessages$c = {
	cartButton: "Ir para o cesto",
	emptyCart: "O cesto está vazio.",
	signInPrompt: "Já tem uma conta? Inicie sessão para ver os artigos selecionados.",
	signInButton: "Iniciar sessão",
	continueButton: "Continuar a comprar",
	checkoutButton: "Finalizar a compra",
	groupTotal: "Preço total do grupo",
	yourItems: "Os seus artigos",
	pricingSummary: "Resumo dos preços",
	youSaved: "Poupou",
	thisOrder: "Esta encomenda",
	productSubtotal: "Subtotal do produto",
	cartLoading: "A preparar o cesto...",
	remove: "Remover",
	basePrice: "Preço base:",
	edit: "Editar"
};
var errorMessages$c = {
	genericIssuesError: "Existem problemas com alguns artigos no seu cesto.",
	fetchingIssuesError: "Lamentamos, mas ocorreu um erro ao carregar o seu cesto.",
	tryAgainOrContactCare: "Se o problema persistir, tente novamente ou contacte o Serviço de apoio ao cliente da VistaPrint."
};
var templateBillingMessages$c = {
	pricingSummaryPayToday: "Esta encomenda",
	"itemPriceLabel:annualSubscription": "Para pagar hoje",
	"templatePriceLabel:annualSubscription": "Subscrição anual",
	"templateSummaryLabel:annualSubscription": "Subscrições anuais",
	"templateSummarySubtotal:annualSubscription": "Pagamento anual",
	"templatePriceUnit:annualSubscription": "{{{price}}}/ano",
	"itemPriceLabel:monthlySubscription": "Para pagar hoje",
	"templatePriceLabel:monthlySubscription": "Subscrição mensal",
	"templateSummaryLabel:monthlySubscription": "Subscrições mensais",
	"templateSummarySubtotal:monthlySubscription": "Pagamento mensal",
	"templatePriceUnit:monthlySubscription": "{{{price}}}/mês"
};
var a11yLabels$c = {
	close: "Fechar",
	hide: "Ocultar",
	show: "Mostrar",
	loading: "A carregar..."
};
var couponMessages$c = {
	enterPromoCode: "Introduza o seu código",
	apply: "Aplicar",
	clear: "Apagar",
	promoCodeApplied: "Código aplicado com êxito.",
	offerDetails: "Detalhes da oferta",
	changeCode: "Alterar código",
	promotionalCode: "Código: {{{promoCode}}}",
	currentPromo: "Código atual:",
	clearPromo: "Limpar código",
	updatePromo: "Atualizar código",
	noPromo: "Nenhum código aplicado",
	addPromoPrompt: "Tem um código?",
	promoCodeClearFailed: "Não foi possível apagar o código de desconto.",
	NotApplicable: "Este código não existe. Experimente utilizar outro.",
	RequiresMissingCustomerGroup: "Este código não é válido para a sua conta. Experimente utilizar outro.",
	Expired: "Este código expirou. Experimente utilizar um ativo.",
	NotLiveYet: "Este código ainda não está ativo. Experimente utilizá-lo novamente mais tarde.",
	UnableToValidate: "Este código não está a funcionar. Experimente utilizá-lo novamente mais tarde.",
	OncePerShopper: "Este código já foi utilizado. Utilize outro.",
	ExceedsUsageLimit: "Este código atingiu o limite de vezes que pode ser utilizado.",
	RequiresLoggedInShopper: "Inicie sessão para aplicar este código."
};
var feeMessages$c = {
	postageFee: "Envio",
	mailingServiceFee: "Serviço de lista de correspondência",
	rushProcessingFee: "Processamento urgente",
	setupFee: "Configuração",
	fallbackFee: "Taxas adicionais"
};
var ptPT = {
	cartItemsCountMessages: cartItemsCountMessages$c,
	cartLabelMessages: cartLabelMessages$c,
	miniCartMessages: miniCartMessages$c,
	errorMessages: errorMessages$c,
	templateBillingMessages: templateBillingMessages$c,
	a11yLabels: a11yLabels$c,
	couponMessages: couponMessages$c,
	feeMessages: feeMessages$c
};

var cartItemsCountMessages$b = {
	cartItemsCount: "Número de artículos en la cesta: ",
	zeroCartItemsCount: "Tu cesta está vacía."
};
var cartLabelMessages$b = {
	cartLabel: "Cesta",
	flyoutTitle: "Mi cesta"
};
var miniCartMessages$b = {
	cartButton: "Ir a la cesta",
	emptyCart: "La cesta está vacía.",
	signInPrompt: "¿Ya tienes una cuenta? Inicia sesión para ver tus artículos seleccionados.",
	signInButton: "Iniciar sesión",
	continueButton: "Seguir comprando",
	checkoutButton: "Tramitar pedido",
	groupTotal: "Total en conjunto",
	yourItems: "Tus artículos",
	pricingSummary: "Lista de precios",
	youSaved: "Ahorras",
	thisOrder: "Este pedido",
	productSubtotal: "Subtotal de productos",
	cartLoading: "Preparando la cesta...",
	remove: "Borrar",
	basePrice: "Precio base:",
	edit: "Modificar"
};
var errorMessages$b = {
	genericIssuesError: "Hay un problema con algunos artículos de tu cesta.",
	fetchingIssuesError: "Lo sentimos, se ha producido un error al cargar tu cesta.",
	tryAgainOrContactCare: "Vuelve a intentarlo o ponte en contacto con el equipo de atención al cliente si el problema persiste."
};
var templateBillingMessages$b = {
	pricingSummaryPayToday: "Este pedido",
	"itemPriceLabel:annualSubscription": "A pagar hoy",
	"templatePriceLabel:annualSubscription": "Suscripción anual",
	"templateSummaryLabel:annualSubscription": "Suscripciones anuales",
	"templateSummarySubtotal:annualSubscription": "Pago anual",
	"templatePriceUnit:annualSubscription": "{{{price}}}/año",
	"itemPriceLabel:monthlySubscription": "A pagar hoy",
	"templatePriceLabel:monthlySubscription": "Suscripción mensual",
	"templateSummaryLabel:monthlySubscription": "Suscripciones mensuales",
	"templateSummarySubtotal:monthlySubscription": "Pago mensual",
	"templatePriceUnit:monthlySubscription": "{{{price}}}/mes"
};
var a11yLabels$b = {
	close: "Cerrar",
	hide: "Ocultar",
	show: "Mostrar",
	loading: "Cargando..."
};
var couponMessages$b = {
	enterPromoCode: "Introduce tu código",
	apply: "Aplicar",
	clear: "Borrar",
	promoCodeApplied: "Código aplicado correctamente.",
	offerDetails: "Detalles de la oferta",
	changeCode: "Cambiar código",
	promotionalCode: "Código: {{{promoCode}}}",
	currentPromo: "Código actual:",
	clearPromo: "Borrar código",
	updatePromo: "Actualizar código",
	noPromo: "No se ha aplicado ningún código",
	addPromoPrompt: "¿Tienes un código?",
	promoCodeClearFailed: "No se puede borrar el código de descuento.",
	NotApplicable: "Este código no existe. Prueba con otro.",
	RequiresMissingCustomerGroup: "Este código no es válido para tu cuenta. Prueba con otro.",
	Expired: "Este código ha caducado. Prueba con uno activo.",
	NotLiveYet: "Este código aún no está activo. Vuelve a intentarlo más tarde.",
	UnableToValidate: "Este código no funciona. Vuelve a intentarlo más tarde.",
	OncePerShopper: "Este código ya se ha utilizado. Utiliza otro diferente.",
	ExceedsUsageLimit: "Este código ya no puede utilizarse más veces.",
	RequiresLoggedInShopper: "Inicia sesión para usar este código."
};
var feeMessages$b = {
	postageFee: "Gastos de envío",
	mailingServiceFee: "Servicio de lista de correo",
	rushProcessingFee: "Procesamiento urgente",
	setupFee: "Configuración",
	fallbackFee: "Recargos adicionales"
};
var esES = {
	cartItemsCountMessages: cartItemsCountMessages$b,
	cartLabelMessages: cartLabelMessages$b,
	miniCartMessages: miniCartMessages$b,
	errorMessages: errorMessages$b,
	templateBillingMessages: templateBillingMessages$b,
	a11yLabels: a11yLabels$b,
	couponMessages: couponMessages$b,
	feeMessages: feeMessages$b
};

var cartItemsCountMessages$a = {
	cartItemsCount: "Number of items in cart: ",
	zeroCartItemsCount: "Your cart is empty."
};
var cartLabelMessages$a = {
	cartLabel: "Cart",
	flyoutTitle: "My Cart"
};
var miniCartMessages$a = {
	cartButton: "Go to cart",
	emptyCart: "Cart is empty.",
	signInPrompt: "Already have an account? Sign in to view your selected items.",
	signInButton: "Sign in",
	continueButton: "Continue shopping",
	checkoutButton: "Checkout",
	groupTotal: "Group total",
	yourItems: "Your items",
	pricingSummary: "Pricing summary",
	youSaved: "You saved",
	thisOrder: "This order",
	productSubtotal: "Product subtotal",
	cartLoading: "Preparing the cart...",
	remove: "Remove",
	basePrice: "Base price:",
	edit: "Edit"
};
var errorMessages$a = {
	genericIssuesError: "There are issues with items in your cart.",
	fetchingIssuesError: "We're sorry, an error occurred loading your cart.",
	tryAgainOrContactCare: "Please try again or contact CARE if this problem persists."
};
var templateBillingMessages$a = {
	pricingSummaryPayToday: "This order",
	"itemPriceLabel:annualSubscription": "To pay today",
	"templatePriceLabel:annualSubscription": "Annual subscription",
	"templateSummaryLabel:annualSubscription": "Annual subscriptions",
	"templateSummarySubtotal:annualSubscription": "Annual payment",
	"templatePriceUnit:annualSubscription": "{{{price}}}/yr",
	"itemPriceLabel:monthlySubscription": "To pay today",
	"templatePriceLabel:monthlySubscription": "Monthly subscription",
	"templateSummaryLabel:monthlySubscription": "Monthly subscriptions",
	"templateSummarySubtotal:monthlySubscription": "Monthly payment",
	"templatePriceUnit:monthlySubscription": "{{{price}}}/mo"
};
var a11yLabels$a = {
	close: "Close",
	hide: "Hide",
	show: "Show",
	loading: "Loading..."
};
var couponMessages$a = {
	enterPromoCode: "Enter your code",
	apply: "Apply",
	clear: "Clear",
	promoCodeApplied: "Code applied successfully.",
	offerDetails: "Offer details",
	changeCode: "Change code",
	promotionalCode: "Code: {{{promoCode}}}",
	currentPromo: "Current code:",
	clearPromo: "Clear code",
	updatePromo: "Update code",
	noPromo: "No code applied",
	addPromoPrompt: "Have a code?",
	promoCodeClearFailed: "Could not clear discount code.",
	NotApplicable: "This code doesn’t exist. Please try another one.",
	RequiresMissingCustomerGroup: "This code isn’t valid for your account. Please try another one.",
	Expired: "This code has expired. Please try an active one.",
	NotLiveYet: "This code isn’t active yet. Please try it again later.",
	UnableToValidate: "This code isn’t working. Please try it again later.",
	OncePerShopper: "This code has already been used. Please use another one.",
	ExceedsUsageLimit: "This code has reached the limit of times it can be used.",
	RequiresLoggedInShopper: "Sign in to apply this code."
};
var feeMessages$a = {
	postageFee: "Postage",
	mailingServiceFee: "Mailing list service",
	rushProcessingFee: "Rush processing",
	setupFee: "Setup",
	fallbackFee: "Additional fees"
};
var enUS = {
	cartItemsCountMessages: cartItemsCountMessages$a,
	cartLabelMessages: cartLabelMessages$a,
	miniCartMessages: miniCartMessages$a,
	errorMessages: errorMessages$a,
	templateBillingMessages: templateBillingMessages$a,
	a11yLabels: a11yLabels$a,
	couponMessages: couponMessages$a,
	feeMessages: feeMessages$a
};

var cartItemsCountMessages$9 = {
	cartItemsCount: "Numero di articoli nel carrello: ",
	zeroCartItemsCount: "Il tuo carrello è vuoto."
};
var cartLabelMessages$9 = {
	cartLabel: "Carrello",
	flyoutTitle: "Il mio carrello"
};
var miniCartMessages$9 = {
	cartButton: "Vai al carrello",
	emptyCart: "Il carrello è vuoto.",
	signInPrompt: "Hai già un account? Accedi per visualizzare gli articoli che hai selezionato.",
	signInButton: "Accedi",
	continueButton: "Continua a fare acquisti",
	checkoutButton: "Conferma ordine",
	groupTotal: "Totale gruppo",
	yourItems: "I tuoi articoli",
	pricingSummary: "Riepilogo prezzi",
	youSaved: "Hai risparmiato",
	thisOrder: "Questo ordine",
	productSubtotal: "Subtotale prodotto",
	cartLoading: "Preparazione del carrello in corso...",
	remove: "Rimuovi",
	basePrice: "Prezzo di base:",
	edit: "Modifica"
};
var errorMessages$9 = {
	genericIssuesError: "Si sono verificati degli errori con degli articoli presenti nel carrello.",
	fetchingIssuesError: "Siamo spiacenti, si è verificato un errore durante il caricamento del carrello.",
	tryAgainOrContactCare: "Prova di nuovo o contatta l’assistenza clienti se il problema persiste."
};
var templateBillingMessages$9 = {
	pricingSummaryPayToday: "Questo ordine",
	"itemPriceLabel:annualSubscription": "Da pagare oggi",
	"templatePriceLabel:annualSubscription": "Abbonamento annuale",
	"templateSummaryLabel:annualSubscription": "Abbonamenti annuali",
	"templateSummarySubtotal:annualSubscription": "Pagamento annuale",
	"templatePriceUnit:annualSubscription": "{{{price}}}/anno",
	"itemPriceLabel:monthlySubscription": "Da pagare oggi",
	"templatePriceLabel:monthlySubscription": "Abbonamento mensile",
	"templateSummaryLabel:monthlySubscription": "Abbonamenti mensili",
	"templateSummarySubtotal:monthlySubscription": "Pagamento mensile",
	"templatePriceUnit:monthlySubscription": "{{{price}}}/mese"
};
var a11yLabels$9 = {
	close: "Chiudi",
	hide: "Nascondi",
	show: "Mostra",
	loading: "Caricamento in corso..."
};
var couponMessages$9 = {
	enterPromoCode: "Inserisci il tuo codice",
	apply: "Applica",
	clear: "Annulla",
	promoCodeApplied: "Codice applicato correttamente.",
	offerDetails: "Dettagli offerta",
	changeCode: "Modifica codice",
	promotionalCode: "Codice: {{{promoCode}}}",
	currentPromo: "Codice attuale:",
	clearPromo: "Rimuovi codice",
	updatePromo: "Aggiorna codice",
	noPromo: "Nessun codice applicato",
	addPromoPrompt: "Hai un codice?",
	promoCodeClearFailed: "Impossibile cancellare il codice sconto.",
	NotApplicable: "Questo codice non esiste. Riprova con un altro codice.",
	RequiresMissingCustomerGroup: "Questo codice non è valido per il tuo account. Riprova con un altro codice.",
	Expired: "Questo codice è scaduto. Riprova con un codice attivo.",
	NotLiveYet: "Questo codice non è ancora attivo. Prova a usarlo più tardi.",
	UnableToValidate: "Questo codice non funziona. Prova a usarlo più tardi.",
	OncePerShopper: "Questo codice è già stato usato. Prova con un altro codice.",
	ExceedsUsageLimit: "Questo codice ha raggiunto il limite di volte che può essere utilizzato.",
	RequiresLoggedInShopper: "Effettua l'accesso per applicare il codice."
};
var feeMessages$9 = {
	postageFee: "Affrancatura",
	mailingServiceFee: "Servizio di mailing list",
	rushProcessingFee: "Elaborazione urgente",
	setupFee: "Preparazione",
	fallbackFee: "Spese aggiuntive"
};
var itIT = {
	cartItemsCountMessages: cartItemsCountMessages$9,
	cartLabelMessages: cartLabelMessages$9,
	miniCartMessages: miniCartMessages$9,
	errorMessages: errorMessages$9,
	templateBillingMessages: templateBillingMessages$9,
	a11yLabels: a11yLabels$9,
	couponMessages: couponMessages$9,
	feeMessages: feeMessages$9
};

var cartItemsCountMessages$8 = {
	cartItemsCount: "Nombre d’articles dans le panier d’achat : ",
	zeroCartItemsCount: "Votre panier d’achat est vide."
};
var cartLabelMessages$8 = {
	cartLabel: "Panier",
	flyoutTitle: "Mon panier"
};
var miniCartMessages$8 = {
	cartButton: "Accéder au panier",
	emptyCart: "Le panier est vide.",
	signInPrompt: "Vous avez déjà un compte ? Connectez-vous pour voir tous les articles sélectionnés.",
	signInButton: "Connexion",
	continueButton: "Continuer vos achats",
	checkoutButton: "Valider mon panier",
	groupTotal: "Total du groupe",
	yourItems: "Vos articles",
	pricingSummary: "Récapitulatif du prix",
	youSaved: "Vous économisez",
	thisOrder: "Cette commande",
	productSubtotal: "Sous-total du produit",
	cartLoading: "Préparation du panier…",
	remove: "Supprimer",
	basePrice: "Prix de base :",
	edit: "Modifier"
};
var errorMessages$8 = {
	genericIssuesError: "Un problème est survenu avec des articles de votre panier.",
	fetchingIssuesError: "Malheureusement, une erreur s’est produite lors du chargement de votre panier d’achat.",
	tryAgainOrContactCare: "Veuillez réessayer ou contacter le service client si le problème persiste."
};
var templateBillingMessages$8 = {
	pricingSummaryPayToday: "Cette commande",
	"itemPriceLabel:annualSubscription": "Payable aujourd’hui",
	"templatePriceLabel:annualSubscription": "Abonnement annuel",
	"templateSummaryLabel:annualSubscription": "Abonnements annuels",
	"templateSummarySubtotal:annualSubscription": "Facturation annuelle",
	"templatePriceUnit:annualSubscription": "{{{price}}}/an",
	"itemPriceLabel:monthlySubscription": "Payable aujourd’hui",
	"templatePriceLabel:monthlySubscription": "Abonnement mensuel",
	"templateSummaryLabel:monthlySubscription": "Abonnements mensuels",
	"templateSummarySubtotal:monthlySubscription": "Facturation mensuelle",
	"templatePriceUnit:monthlySubscription": "{{{price}}}/mois"
};
var a11yLabels$8 = {
	close: "Fermer",
	hide: "Masquer",
	show: "Afficher",
	loading: "Chargement…"
};
var couponMessages$8 = {
	enterPromoCode: "Saisissez votre code",
	apply: "Appliquer",
	clear: "Effacer",
	promoCodeApplied: "Le code a bien été appliqué.",
	offerDetails: "Détails de l’offre",
	changeCode: "Changer le code",
	promotionalCode: "Code : {{{promoCode}}}",
	currentPromo: "Code actuel :",
	clearPromo: "Effacer le code",
	updatePromo: "Actualiser le code",
	noPromo: "Aucun code appliqué",
	addPromoPrompt: "Avez-vous un code ?",
	promoCodeClearFailed: "Le code promo n’a pas pu être effacé.",
	NotApplicable: "Ce code n’existe pas. Veuillez essayer un autre code.",
	RequiresMissingCustomerGroup: "Ce code n’est pas valide pour votre compte. Veuillez essayer un autre code.",
	Expired: "Ce code a expiré. Veuillez essayer un code actif.",
	NotLiveYet: "Ce code n’est pas encore actif. Veuillez essayer de l’utiliser plus tard.",
	UnableToValidate: "Ce code ne fonctionne pas. Veuillez essayer de l’utiliser plus tard.",
	OncePerShopper: "Ce code a déjà été utilisé. Veuillez utiliser un autre code.",
	ExceedsUsageLimit: "Ce code a atteint le nombre limite d’utilisations autorisées.",
	RequiresLoggedInShopper: "Connectez-vous pour appliquer ce code."
};
var feeMessages$8 = {
	postageFee: "Frais postaux",
	mailingServiceFee: "Liste de distribution",
	rushProcessingFee: "Traitement express",
	setupFee: "Configuration",
	fallbackFee: "Frais supplémentaires"
};
var frFR = {
	cartItemsCountMessages: cartItemsCountMessages$8,
	cartLabelMessages: cartLabelMessages$8,
	miniCartMessages: miniCartMessages$8,
	errorMessages: errorMessages$8,
	templateBillingMessages: templateBillingMessages$8,
	a11yLabels: a11yLabels$8,
	couponMessages: couponMessages$8,
	feeMessages: feeMessages$8
};

var cartItemsCountMessages$7 = {
	cartItemsCount: "Anzahl an Artikeln im Warenkorb: ",
	zeroCartItemsCount: "Ihr Warenkorb ist leer."
};
var cartLabelMessages$7 = {
	cartLabel: "Warenkorb",
	flyoutTitle: "Mein Warenkorb"
};
var miniCartMessages$7 = {
	cartButton: "Zum Warenkorb",
	emptyCart: "Warenkorb ist leer.",
	signInPrompt: "Sie haben schon ein Konto? Loggen Sie sich ein, um Ihre ausgewählten Artikel anzusehen.",
	signInButton: "Einloggen",
	continueButton: "Mehr shoppen",
	checkoutButton: "Kasse",
	groupTotal: "Gesamtpreis",
	yourItems: "Ihre Artikel",
	pricingSummary: "Preisübersicht",
	youSaved: "So viel haben Sie gespart",
	thisOrder: "Diese Bestellung",
	productSubtotal: "Zwischensumme",
	cartLoading: "Warenkorb wird vorbereitet ...",
	remove: "Entfernen",
	basePrice: "Grundpreis:",
	edit: "Bearbeiten"
};
var errorMessages$7 = {
	genericIssuesError: "Es gibt Probleme mit Artikeln in Ihrem Warenkorb.",
	fetchingIssuesError: "Leider ist beim Laden Ihres Warenkorbs ein Fehler aufgetreten.",
	tryAgainOrContactCare: "Versuchen Sie es noch einmal oder kontaktieren Sie den Kundenservice, falls das Problem fortbesteht."
};
var templateBillingMessages$7 = {
	pricingSummaryPayToday: "Diese Bestellung",
	"itemPriceLabel:annualSubscription": "Heute fälliger Betrag",
	"templatePriceLabel:annualSubscription": "Jahresabo",
	"templateSummaryLabel:annualSubscription": "Jahresabos",
	"templateSummarySubtotal:annualSubscription": "Jährliche Zahlung",
	"templatePriceUnit:annualSubscription": "{{{price}}}/Jahr",
	"itemPriceLabel:monthlySubscription": "Heute fälliger Betrag",
	"templatePriceLabel:monthlySubscription": "Monatsabo",
	"templateSummaryLabel:monthlySubscription": "Monatsabos",
	"templateSummarySubtotal:monthlySubscription": "Monatliche Zahlung",
	"templatePriceUnit:monthlySubscription": "{{{price}}}/Monat"
};
var a11yLabels$7 = {
	close: "Schließen",
	hide: "Verbergen",
	show: "Anzeigen",
	loading: "Wird geladen…"
};
var couponMessages$7 = {
	enterPromoCode: "Code eingeben",
	apply: "Anwenden",
	clear: "Löschen",
	promoCodeApplied: "Der Code wurde erfolgreich angewandt.",
	offerDetails: "Angebotsdetails",
	changeCode: "Code ändern",
	promotionalCode: "Code: {{{promoCode}}}",
	currentPromo: "Aktueller Code:",
	clearPromo: "Code löschen",
	updatePromo: "Code aktualisieren",
	noPromo: "Kein Code angewendet",
	addPromoPrompt: "Haben Sie einen Angebotscode?",
	promoCodeClearFailed: "Rabattcode konnte nicht gelöscht werden.",
	NotApplicable: "Dieser Code existiert nicht. Versuchen Sie es mit einem anderen Code noch einmal.",
	RequiresMissingCustomerGroup: "Dieser Code ist für Ihr Konto nicht gültig. Versuchen Sie es mit einem anderen Code noch einmal.",
	Expired: "Dieser Code ist nicht mehr gültig. Versuchen Sie es mit einem gültigen Code noch einmal.",
	NotLiveYet: "Dieser Code wurde noch nicht aktiviert. Bitte versuchen Sie es später erneut.",
	UnableToValidate: "Dieser Code wurde nicht erkannt. Bitte versuchen Sie es später erneut.",
	OncePerShopper: "Dieser Code wurde bereits eingelöst. Geben Sie einen anderen Code ein.",
	ExceedsUsageLimit: "Dieser Code wurde bereits so oft eingelöst wie möglich.",
	RequiresLoggedInShopper: "Loggen Sie sich ein, um diesen Code anzuwenden."
};
var feeMessages$7 = {
	postageFee: "Porto",
	mailingServiceFee: "Verteilerlistenservice",
	rushProcessingFee: "Expressbearbeitung",
	setupFee: "Einrichtung",
	fallbackFee: "Zusätzliche Gebühren"
};
var deDE = {
	cartItemsCountMessages: cartItemsCountMessages$7,
	cartLabelMessages: cartLabelMessages$7,
	miniCartMessages: miniCartMessages$7,
	errorMessages: errorMessages$7,
	templateBillingMessages: templateBillingMessages$7,
	a11yLabels: a11yLabels$7,
	couponMessages: couponMessages$7,
	feeMessages: feeMessages$7
};

var cartItemsCountMessages$6 = {
	cartItemsCount: "Antal varer i indkøbsvognen: ",
	zeroCartItemsCount: "Din indkøbsvogn er tom."
};
var cartLabelMessages$6 = {
	cartLabel: "Indkøbsvogn",
	flyoutTitle: "Min indkøbsvogn"
};
var miniCartMessages$6 = {
	cartButton: "Gå til indkøbsvognen",
	emptyCart: "Indkøbsvognen er tom.",
	signInPrompt: "Har du allerede en konto? Log ind for at se dine valgte varer.",
	signInButton: "Log ind",
	continueButton: "Fortsæt indkøb",
	checkoutButton: "Gå til kassen",
	groupTotal: "Gruppe i alt",
	yourItems: "Dine produkter",
	pricingSummary: "Prisoversigt",
	youSaved: "Du har sparet",
	thisOrder: "Denne bestilling",
	productSubtotal: "Subtotal for produkter",
	cartLoading: "Forbereder indkøbsvognen ...",
	remove: "Fjern",
	basePrice: "Basispris:",
	edit: "Rediger"
};
var errorMessages$6 = {
	genericIssuesError: "Der er problemer med produkterne i indkøbsvognen.",
	fetchingIssuesError: "Beklager, der opstod en fejl ved indlæsning af din indkøbsvogn.",
	tryAgainOrContactCare: "Prøv igen, eller kontakt kundeservice, hvis problemet fortsætter."
};
var templateBillingMessages$6 = {
	pricingSummaryPayToday: "Denne bestilling",
	"itemPriceLabel:annualSubscription": "At betale i dag",
	"templatePriceLabel:annualSubscription": "Årligt abonnement",
	"templateSummaryLabel:annualSubscription": "Årlige abonnementer",
	"templateSummarySubtotal:annualSubscription": "Årlig betaling",
	"templatePriceUnit:annualSubscription": "{{{price}}}/år",
	"itemPriceLabel:monthlySubscription": "At betale i dag",
	"templatePriceLabel:monthlySubscription": "Månedligt abonnement",
	"templateSummaryLabel:monthlySubscription": "Månedlige abonnementer",
	"templateSummarySubtotal:monthlySubscription": "Månedlig betaling",
	"templatePriceUnit:monthlySubscription": "{{{price}}}/md"
};
var a11yLabels$6 = {
	close: "Luk",
	hide: "Skjul",
	show: "Vis",
	loading: "Indlæser ..."
};
var couponMessages$6 = {
	enterPromoCode: "Indtast din kode",
	apply: "Anvend",
	clear: "Transparent",
	promoCodeApplied: "Koden blev anvendt.",
	offerDetails: "Detaljer om tilbuddet",
	changeCode: "Skift kode",
	promotionalCode: "Rabatkode: {{{promoCode}}}",
	currentPromo: "Aktuel kode:",
	clearPromo: "Ryd kode",
	updatePromo: "Opdater kode",
	noPromo: "Ingen rabatkode aktiveret",
	addPromoPrompt: "Har du en rabatkode?",
	promoCodeClearFailed: "Kunne ikke slette rabatkode.",
	NotApplicable: "Denne kode findes ikke. Prøv en anden.",
	RequiresMissingCustomerGroup: "Denne rabatkode er ikke gyldig for din konto. Prøv en anden.",
	Expired: "Denne kode er udløbet. Prøv en aktiv kode.",
	NotLiveYet: "Denne kode er ikke aktiv endnu. Prøv igen senere.",
	UnableToValidate: "Denne kode virker ikke. Prøv igen senere.",
	OncePerShopper: "Denne rabatkode er allerede blevet brugt. Benyt venligst en anden.",
	ExceedsUsageLimit: "Denne kode har nået grænsen for, hvor mange gange den kan bruges.",
	RequiresLoggedInShopper: "Log ind for at anvende denne kode."
};
var feeMessages$6 = {
	postageFee: "Porto",
	mailingServiceFee: "Mailingliste-service",
	rushProcessingFee: "Hastebehandling",
	setupFee: "Opsætning",
	fallbackFee: "Ekstragebyr"
};
var daDK = {
	cartItemsCountMessages: cartItemsCountMessages$6,
	cartLabelMessages: cartLabelMessages$6,
	miniCartMessages: miniCartMessages$6,
	errorMessages: errorMessages$6,
	templateBillingMessages: templateBillingMessages$6,
	a11yLabels: a11yLabels$6,
	couponMessages: couponMessages$6,
	feeMessages: feeMessages$6
};

var cartItemsCountMessages$5 = {
	cartItemsCount: "Antal artiklar i kundvagn: ",
	zeroCartItemsCount: "Din kundvagn är tom."
};
var cartLabelMessages$5 = {
	cartLabel: "Kundvagn",
	flyoutTitle: "Min kundvagn"
};
var miniCartMessages$5 = {
	cartButton: "Gå till kundvagn",
	emptyCart: "Kundvagnen är tom.",
	signInPrompt: "Har du redan ett konto? Logga in för att se dina valda artiklar.",
	signInButton: "Logga in",
	continueButton: "Fortsätt handla",
	checkoutButton: "Kassa",
	groupTotal: "Totalbelopp samling",
	yourItems: "Dina artiklar",
	pricingSummary: "Prissammanfattning",
	youSaved: "Du har sparat",
	thisOrder: "Den här beställningen",
	productSubtotal: "Delsumma för produkter",
	cartLoading: "Förbereder kundvagn ...",
	remove: "Ta bort",
	basePrice: "Grundpris:",
	edit: "Redigera"
};
var errorMessages$5 = {
	genericIssuesError: "Det är problem med artiklar i kundvagnen.",
	fetchingIssuesError: "Ett fel uppstod tyvärr när kundvagnen skulle laddas.",
	tryAgainOrContactCare: "Försök igen eller kontakta kundservice om problemet kvarstår."
};
var templateBillingMessages$5 = {
	pricingSummaryPayToday: "Den här beställningen",
	"itemPriceLabel:annualSubscription": "Att betala idag",
	"templatePriceLabel:annualSubscription": "Årsabonnemang",
	"templateSummaryLabel:annualSubscription": "Årsabonnemang",
	"templateSummarySubtotal:annualSubscription": "Årlig betalning",
	"templatePriceUnit:annualSubscription": "{{{price}}}/år",
	"itemPriceLabel:monthlySubscription": "Att betala idag",
	"templatePriceLabel:monthlySubscription": "Månadsabonnemang",
	"templateSummaryLabel:monthlySubscription": "Månadsabonnemang",
	"templateSummarySubtotal:monthlySubscription": "Månadsbetalning",
	"templatePriceUnit:monthlySubscription": "{{{price}}}/mån"
};
var a11yLabels$5 = {
	close: "Stäng",
	hide: "Dölj",
	show: "Visa",
	loading: "Läser in ..."
};
var couponMessages$5 = {
	enterPromoCode: "Ange din kod",
	apply: "Tillämpa",
	clear: "Genomskinliga",
	promoCodeApplied: "Koden har tillämpats.",
	offerDetails: "Information om erbjudandet",
	changeCode: "Ändra kod",
	promotionalCode: "Kod: {{{promoCode}}}",
	currentPromo: "Nuvarande kod:",
	clearPromo: "Rensa kod",
	updatePromo: "Uppdatera kod",
	noPromo: "Ingen kod har aktiverats",
	addPromoPrompt: "Har du en kod?",
	promoCodeClearFailed: "Det gick inte att rensa rabattkoden.",
	NotApplicable: "Den här koden existerar inte. Pröva med en annan.",
	RequiresMissingCustomerGroup: "Den här koden är inte giltig för ditt konto. Pröva med en annan.",
	Expired: "Den här koden har gått ut. Försök med en som gäller.",
	NotLiveYet: "Den här koden är inte giltig än. Försök igen senare.",
	UnableToValidate: "Den här koden fungerar inte. Försök igen senare.",
	OncePerShopper: "Den här koden har redan använts. Pröva med en annan.",
	ExceedsUsageLimit: "Den här koden har nått gränsen för hur många gånger den kan användas.",
	RequiresLoggedInShopper: "Logga in för att tillämpa koden."
};
var feeMessages$5 = {
	postageFee: "Porto",
	mailingServiceFee: "Utskickslista som tjänst",
	rushProcessingFee: "Expresshantering",
	setupFee: "Konfiguration",
	fallbackFee: "Ytterligare avgifter"
};
var svSE = {
	cartItemsCountMessages: cartItemsCountMessages$5,
	cartLabelMessages: cartLabelMessages$5,
	miniCartMessages: miniCartMessages$5,
	errorMessages: errorMessages$5,
	templateBillingMessages: templateBillingMessages$5,
	a11yLabels: a11yLabels$5,
	couponMessages: couponMessages$5,
	feeMessages: feeMessages$5
};

var cartItemsCountMessages$4 = {
	cartItemsCount: "Antall artikler i handlevognen: ",
	zeroCartItemsCount: "Handlevognen din er tom."
};
var cartLabelMessages$4 = {
	cartLabel: "Handlevogn",
	flyoutTitle: "Handlevogn"
};
var miniCartMessages$4 = {
	cartButton: "Legg i handlevognen",
	emptyCart: "Handlevognen din er tom.",
	signInPrompt: "Har du allerede en konto? Logg inn for å se produktene du har valgt.",
	signInButton: "Logg inn",
	continueButton: "Handle mer",
	checkoutButton: "Gå til kassen",
	groupTotal: "Totalt gruppe",
	yourItems: "Dine varer",
	pricingSummary: "Prisoversikt",
	youSaved: "Du sparte",
	thisOrder: "Denne bestillingen",
	productSubtotal: "Delsum produkt",
	cartLoading: "Forbereder handlevognen …",
	remove: "Fjern",
	basePrice: "Grunnpris:",
	edit: "Redigere"
};
var errorMessages$4 = {
	genericIssuesError: "Det oppsto problemer med varene i handlevognen din.",
	fetchingIssuesError: "Vi beklager, men det oppstod en feil under opplastingen av handlevognen din.",
	tryAgainOrContactCare: "Prøv på nytt, eller ta kontakt med kundeservice hvis problemet vedvarer."
};
var templateBillingMessages$4 = {
	pricingSummaryPayToday: "Denne bestillingen",
	"itemPriceLabel:annualSubscription": "Må betales i dag",
	"templatePriceLabel:annualSubscription": "Årlig abonnement",
	"templateSummaryLabel:annualSubscription": "Årlige abonnementer",
	"templateSummarySubtotal:annualSubscription": "Årlig betaling",
	"templatePriceUnit:annualSubscription": "{{{price}}}/år",
	"itemPriceLabel:monthlySubscription": "Må betales i dag",
	"templatePriceLabel:monthlySubscription": "Månedlig abonnement",
	"templateSummaryLabel:monthlySubscription": "Månedlige abonnementer",
	"templateSummarySubtotal:monthlySubscription": "Månedlig betaling",
	"templatePriceUnit:monthlySubscription": "{{{price}}}/mnd."
};
var a11yLabels$4 = {
	close: "Lukk",
	hide: "Skjul",
	show: "Vis",
	loading: "Laster ..."
};
var couponMessages$4 = {
	enterPromoCode: "Legg til koden din",
	apply: "Bruk",
	clear: "Fjern",
	promoCodeApplied: "Koden er påført.",
	offerDetails: "Tilbudsopplysninger",
	changeCode: "Endre kode",
	promotionalCode: "Kode: {{{promoCode}}}",
	currentPromo: "Aktuell kode:",
	clearPromo: "Fjern kode",
	updatePromo: "Oppdater kode",
	noPromo: "Ingen kode brukt",
	addPromoPrompt: "Har du en kode?",
	promoCodeClearFailed: "Kunne ikke fjerne rabattkode.",
	NotApplicable: "Denne koden finnes ikke. Prøv heller en annen.",
	RequiresMissingCustomerGroup: "Denne koden er ikke gyldig for kontoen din. Prøv heller en annen.",
	Expired: "Denne koden er utløpt. Prøv heller en aktiv kode.",
	NotLiveYet: "Denne koden er ikke aktiv enda. Prøv igjen senere.",
	UnableToValidate: "Denne koden fungerer ikke. Prøv igjen senere.",
	OncePerShopper: "Denne koden er allerede brukt. Prøv en annen kode.",
	ExceedsUsageLimit: "Denne koden kan ikke brukes flere ganger.",
	RequiresLoggedInShopper: "Logg inn for å bruke denne koden."
};
var feeMessages$4 = {
	postageFee: "Porto",
	mailingServiceFee: "Tjeneste for e-postutsendelser",
	rushProcessingFee: "Rask behandling",
	setupFee: "Oppstart",
	fallbackFee: "Ekstra kostnader"
};
var nbNO = {
	cartItemsCountMessages: cartItemsCountMessages$4,
	cartLabelMessages: cartLabelMessages$4,
	miniCartMessages: miniCartMessages$4,
	errorMessages: errorMessages$4,
	templateBillingMessages: templateBillingMessages$4,
	a11yLabels: a11yLabels$4,
	couponMessages: couponMessages$4,
	feeMessages: feeMessages$4
};

var cartItemsCountMessages$3 = {
	cartItemsCount: "Ostoskorin tuotteiden lukumäärä: ",
	zeroCartItemsCount: "Ostoskori on tyhjä."
};
var cartLabelMessages$3 = {
	cartLabel: "Ostoskori",
	flyoutTitle: "Oma ostoskori"
};
var miniCartMessages$3 = {
	cartButton: "Siirry ostoskoriin",
	emptyCart: "Ostoskori on tyhjä.",
	signInPrompt: "Onko sinulla jo tili? Kirjaudu sisään nähdäksesi valitsemasi tuotteet.",
	signInButton: "Kirjaudu sisään",
	continueButton: "Jatka ostoksia",
	checkoutButton: "Kassa",
	groupTotal: "Ryhmä yhteensä",
	yourItems: "Tuotteesi",
	pricingSummary: "Hintojen yhteenveto",
	youSaved: "Säästit",
	thisOrder: "Tämä tilaus",
	productSubtotal: "Tuotteiden välisumma",
	cartLoading: "Valmistellaan ostoskoria...",
	remove: "Poista",
	basePrice: "Perushinta:",
	edit: "Muokkaa"
};
var errorMessages$3 = {
	genericIssuesError: "Ostoskorissasi oleviin tuotteisiin liittyy ongelmia.",
	fetchingIssuesError: "Ostoskoriasi ladattaessa tapahtui virhe.",
	tryAgainOrContactCare: "Yritä uudelleen tai ota yhteyttä tukeen, jos ongelma jatkuu."
};
var templateBillingMessages$3 = {
	pricingSummaryPayToday: "Tämä tilaus",
	"itemPriceLabel:annualSubscription": "Maksetaan tänään",
	"templatePriceLabel:annualSubscription": "Vuositilaus",
	"templateSummaryLabel:annualSubscription": "Vuositilaukset",
	"templateSummarySubtotal:annualSubscription": "Vuosimaksu",
	"templatePriceUnit:annualSubscription": "{{{price}}}/vuosi",
	"itemPriceLabel:monthlySubscription": "Maksetaan tänään",
	"templatePriceLabel:monthlySubscription": "Kuukausitilaus",
	"templateSummaryLabel:monthlySubscription": "Kuukausitilaukset",
	"templateSummarySubtotal:monthlySubscription": "Kuukausimaksu",
	"templatePriceUnit:monthlySubscription": "{{{price}}}/kk"
};
var a11yLabels$3 = {
	close: "Sulje",
	hide: "Piilota",
	show: "Näytä",
	loading: "Ladataan..."
};
var couponMessages$3 = {
	enterPromoCode: "Lisää koodi",
	apply: "Käytä",
	clear: "Tyhjennä",
	promoCodeApplied: "Koodi käytetty onnistuneesti",
	offerDetails: "Tarjouksen tiedot",
	changeCode: "Vaihda koodia",
	promotionalCode: "Koodi: {{{promoCode}}}",
	currentPromo: "Nykyinen koodi: ",
	clearPromo: "Tyhjennä koodi",
	updatePromo: "Päivitä koodi",
	noPromo: "Koodia ei käytetty",
	addPromoPrompt: "Onko sinulla koodi?",
	promoCodeClearFailed: "Alennuskoodin tyhjentäminen ei onnistunut.",
	NotApplicable: "Koodia ei tunnisteta. Yritä käyttää jotakin muuta koodia.",
	RequiresMissingCustomerGroup: "Koodia ei voida käyttää tililläsi. Yritä käyttää jotakin muuta koodia.",
	Expired: "Koodi on vanhentunut. Kokeile voimassaolevaa koodia.",
	NotLiveYet: "Koodi ei ole vielä voimassa. Yritä myöhemmin uudelleen.",
	UnableToValidate: "Koodi ei toimi. Yritä myöhemmin uudelleen.",
	OncePerShopper: "Koodi on jo käytetty. Kokeile toista koodia.",
	ExceedsUsageLimit: "Koodia ei voi enää käyttää.",
	RequiresLoggedInShopper: "Kirjaudu sisään käyttääksesi tätä koodia."
};
var feeMessages$3 = {
	postageFee: "Lähetys ja käsittely",
	mailingServiceFee: "Postituslistapalvelu",
	rushProcessingFee: "Käsitellään kiireellisenä",
	setupFee: "Järjestely",
	fallbackFee: "Lisämaksut"
};
var fiFI = {
	cartItemsCountMessages: cartItemsCountMessages$3,
	cartLabelMessages: cartLabelMessages$3,
	miniCartMessages: miniCartMessages$3,
	errorMessages: errorMessages$3,
	templateBillingMessages: templateBillingMessages$3,
	a11yLabels: a11yLabels$3,
	couponMessages: couponMessages$3,
	feeMessages: feeMessages$3
};

var cartItemsCountMessages$2 = {
	cartItemsCount: "Aantal artikelen in je winkelwagentje: ",
	zeroCartItemsCount: "Je winkelwagentje is leeg."
};
var cartLabelMessages$2 = {
	cartLabel: "Winkelwagentje",
	flyoutTitle: "Mijn winkelwagentje"
};
var miniCartMessages$2 = {
	cartButton: "Ga naar winkelwagentje",
	emptyCart: "Winkelwagentje is leeg.",
	signInPrompt: "Heb je al een account? Log in om je geselecteerde artikelen te zien.",
	signInButton: "Log in",
	continueButton: "Doorgaan met winkelen",
	checkoutButton: "Betaalpagina",
	groupTotal: "Totaal groep",
	yourItems: "Jouw artikelen",
	pricingSummary: "Prijsoverzicht",
	youSaved: "Je bespaart",
	thisOrder: "Deze bestelling",
	productSubtotal: "Subtotaal van je producten",
	cartLoading: "Winkelwagentje voorbereiden...",
	remove: "Verwijderen",
	basePrice: "Basisprijs:",
	edit: "Bewerken"
};
var errorMessages$2 = {
	genericIssuesError: "Er zijn problemen met artikelen in je winkelwagentje.",
	fetchingIssuesError: "Er is helaas een fout opgetreden tijdens het laden van je winkelwagentje.",
	tryAgainOrContactCare: "Probeer het opnieuw of neem contact op met de klantenservice als het probleem zich blijft voordoen."
};
var templateBillingMessages$2 = {
	pricingSummaryPayToday: "Deze bestelling",
	"itemPriceLabel:annualSubscription": "Vandaag te betalen",
	"templatePriceLabel:annualSubscription": "Jaarabonnement",
	"templateSummaryLabel:annualSubscription": "Jaarabonnementen",
	"templateSummarySubtotal:annualSubscription": "Betaling per jaar",
	"templatePriceUnit:annualSubscription": "{{{price}}}/jaar",
	"itemPriceLabel:monthlySubscription": "Vandaag te betalen",
	"templatePriceLabel:monthlySubscription": "Maandabonnement",
	"templateSummaryLabel:monthlySubscription": "Maandabonnementen",
	"templateSummarySubtotal:monthlySubscription": "Betaling per maand",
	"templatePriceUnit:monthlySubscription": "{{{price}}}/maand"
};
var a11yLabels$2 = {
	close: "Sluiten",
	hide: "Verbergen",
	show: "Weergeven",
	loading: "Bezig met laden..."
};
var couponMessages$2 = {
	enterPromoCode: "Voer je code in",
	apply: "Toepassen",
	clear: "Verwijderen",
	promoCodeApplied: "Code is toegepast.",
	offerDetails: "Details van de aanbieding",
	changeCode: "Code wijzigen",
	promotionalCode: "Code: {{{promoCode}}}",
	currentPromo: "Huidige code:",
	clearPromo: "Code wissen",
	updatePromo: "Code bijwerken",
	noPromo: "Geen code toegepast",
	addPromoPrompt: "Heb je een code?",
	promoCodeClearFailed: "Kortingscode verwijderen is mislukt.",
	NotApplicable: "Deze code bestaat niet. Probeer een andere.",
	RequiresMissingCustomerGroup: "Deze code is niet geldig voor je account. Probeer een andere.",
	Expired: "Deze code is verlopen. Probeer een actieve code.",
	NotLiveYet: "Deze code is nog niet actief. Probeer het later opnieuw.",
	UnableToValidate: "Deze code werkt niet. Probeer het later opnieuw.",
	OncePerShopper: "Deze code is al gebruikt. Gebruik een andere.",
	ExceedsUsageLimit: "Deze code is het maximaal aantal keren gebruikt.",
	RequiresLoggedInShopper: "Log in om deze code toe te passen."
};
var feeMessages$2 = {
	postageFee: "Frankeren",
	mailingServiceFee: "Mailinglijstdiensten",
	rushProcessingFee: "Spoedverwerking",
	setupFee: "Instellen",
	fallbackFee: "Extra kosten"
};
var nlNL = {
	cartItemsCountMessages: cartItemsCountMessages$2,
	cartLabelMessages: cartLabelMessages$2,
	miniCartMessages: miniCartMessages$2,
	errorMessages: errorMessages$2,
	templateBillingMessages: templateBillingMessages$2,
	a11yLabels: a11yLabels$2,
	couponMessages: couponMessages$2,
	feeMessages: feeMessages$2
};

var cartItemsCountMessages$1 = {
	cartItemsCount: "Nombre d’articles dans le panier : ",
	zeroCartItemsCount: "Votre panier est vide."
};
var cartLabelMessages$1 = {
	cartLabel: "Panier",
	flyoutTitle: "Mon panier"
};
var miniCartMessages$1 = {
	cartButton: "Accéder au panier",
	emptyCart: "Le panier est vide.",
	signInPrompt: "Vous avez déjà un compte? Connectez-vous pour voir les articles que vous avez sélectionnés.",
	signInButton: "Se connecter",
	continueButton: "Poursuivre mes achats",
	checkoutButton: "Payer",
	groupTotal: "Total final",
	yourItems: "Vos articles",
	pricingSummary: "Résumé des prix",
	youSaved: "Vous avez économisé",
	thisOrder: "Cette commande",
	productSubtotal: "Sous-total produits",
	cartLoading: "Panier en cours de préparation...",
	remove: "Supprimer",
	basePrice: "Prix de base :",
	edit: "Modifier"
};
var errorMessages$1 = {
	genericIssuesError: "Certains articles de votre panier posent des problèmes.",
	fetchingIssuesError: "Toutes nos excuses, une erreur s’est produite lors du chargement de votre panier.",
	tryAgainOrContactCare: "Veuillez réessayer ou contacter le service à la clientèle si ce problème persiste."
};
var templateBillingMessages$1 = {
	pricingSummaryPayToday: "Cette commande",
	"itemPriceLabel:annualSubscription": "À payer aujourd’hui",
	"templatePriceLabel:annualSubscription": "Abonnement annuel",
	"templateSummaryLabel:annualSubscription": "Abonnements annuels",
	"templateSummarySubtotal:annualSubscription": "Paiement annuel",
	"templatePriceUnit:annualSubscription": "{{{price}}}/an",
	"itemPriceLabel:monthlySubscription": "À payer aujourd’hui",
	"templatePriceLabel:monthlySubscription": "Abonnement mensuel",
	"templateSummaryLabel:monthlySubscription": "Abonnements mensuels",
	"templateSummarySubtotal:monthlySubscription": "Paiement mensuel",
	"templatePriceUnit:monthlySubscription": "{{{price}}}/mois"
};
var a11yLabels$1 = {
	close: "Fermer",
	hide: "Masquer",
	show: "Afficher",
	loading: "Chargement en cours..."
};
var couponMessages$1 = {
	enterPromoCode: "Saisissez votre code",
	apply: "Appliquer",
	clear: "Effacer",
	promoCodeApplied: "Le code a bien été appliqué.",
	offerDetails: "Détails de l’offre",
	changeCode: "Changer le code",
	promotionalCode: "Code : {{{promoCode}}}",
	currentPromo: "Code actuel :",
	clearPromo: "Effacer le code",
	updatePromo: "Actualiser le code",
	noPromo: "Aucun code appliqué",
	addPromoPrompt: "Vous avez un code?",
	promoCodeClearFailed: "Impossible d’effacer le code de réduction.",
	NotApplicable: "Ce code n’existe pas. Veuillez en essayer un autre.",
	RequiresMissingCustomerGroup: "Ce code n’est pas valide pour votre compte. Veuillez en essayer un autre.",
	Expired: "Ce code a expiré. Veuillez utiliser un code actif.",
	NotLiveYet: "Ce code n’est pas encore actif. Veuillez réessayer plus tard.",
	UnableToValidate: "Ce code ne fonctionne pas. Veuillez réessayer plus tard.",
	OncePerShopper: "Ce code a déjà été utilisé. Veuillez en utiliser un autre.",
	ExceedsUsageLimit: "Ce code a atteint le maximum d’utilisations possibles.",
	RequiresLoggedInShopper: "Connectez-vous pour appliquer ce code."
};
var feeMessages$1 = {
	postageFee: "Affranchissement",
	mailingServiceFee: "Service de liste d’envoi",
	rushProcessingFee: "Traitement urgent",
	setupFee: "Mise en route",
	fallbackFee: "Frais supplémentaires"
};
var frCA = {
	cartItemsCountMessages: cartItemsCountMessages$1,
	cartLabelMessages: cartLabelMessages$1,
	miniCartMessages: miniCartMessages$1,
	errorMessages: errorMessages$1,
	templateBillingMessages: templateBillingMessages$1,
	a11yLabels: a11yLabels$1,
	couponMessages: couponMessages$1,
	feeMessages: feeMessages$1
};

var cartItemsCountMessages = {
	cartItemsCount: "Cantidad de artículos en el carrito: ",
	zeroCartItemsCount: "Su carrito está vacío."
};
var cartLabelMessages = {
	cartLabel: "Carrito",
	flyoutTitle: "Mi carrito"
};
var miniCartMessages = {
	cartButton: "Ir al carrito",
	emptyCart: "El carrito está vacío.",
	signInPrompt: "¿Ya tiene una cuenta? Inicie sesión para ver los artículos que seleccionó.",
	signInButton: "Iniciar sesión",
	continueButton: "Continuar comprando",
	checkoutButton: "Finalizar la compra",
	groupTotal: "Total del grupo",
	yourItems: "Sus artículos",
	pricingSummary: "Resumen de precios",
	youSaved: "Usted ahorró",
	thisOrder: "Este pedido",
	productSubtotal: "Subtotal del producto",
	cartLoading: "Preparando su carrito...",
	remove: "Eliminar",
	basePrice: "Precio base:",
	edit: "Editar"
};
var errorMessages = {
	genericIssuesError: "Hay problemas con algunos artículos en su carrito.",
	fetchingIssuesError: "Lo sentimos, se produjo un error al cargar su carrito.",
	tryAgainOrContactCare: "Vuelva a intentarlo o comuníquese con CARE si el problema persiste."
};
var templateBillingMessages = {
	pricingSummaryPayToday: "Este pedido",
	"itemPriceLabel:annualSubscription": "A pagar el día de hoy",
	"templatePriceLabel:annualSubscription": "Suscripción anual",
	"templateSummaryLabel:annualSubscription": "Suscripciones anuales",
	"templateSummarySubtotal:annualSubscription": "Pago anual",
	"templatePriceUnit:annualSubscription": "{{{price}}}/año",
	"itemPriceLabel:monthlySubscription": "A pagar el día de hoy",
	"templatePriceLabel:monthlySubscription": "Suscripción mensual",
	"templateSummaryLabel:monthlySubscription": "Suscripciones mensuales",
	"templateSummarySubtotal:monthlySubscription": "Pago mensual",
	"templatePriceUnit:monthlySubscription": "{{{price}}}/mes"
};
var a11yLabels = {
	close: "Cerrar",
	hide: "Ocultar",
	show: "Mostrar",
	loading: "Cargando..."
};
var couponMessages = {
	enterPromoCode: "Ingrese su código",
	apply: "Aplicar",
	clear: "Borrar",
	promoCodeApplied: "Código aplicado correctamente.",
	offerDetails: "Detalles de la oferta",
	changeCode: "Cambiar el código",
	promotionalCode: "Código: {{{promoCode}}}",
	currentPromo: "Código actual:",
	clearPromo: "Borrar código",
	updatePromo: "Actualizar código",
	noPromo: "No se aplicó el código",
	addPromoPrompt: "¿Tiene un código?",
	promoCodeClearFailed: "No se pudo borrar el código de descuento.",
	NotApplicable: "Este código no existe. Pruebe con otro.",
	RequiresMissingCustomerGroup: "Este código no es válido para su cuenta. Pruebe con otro.",
	Expired: "Este código está vencido. Pruebe con otro que esté activo.",
	NotLiveYet: "Este código no está activo todavía. Vuelva a intentarlo más adelante.",
	UnableToValidate: "Este código no está funcionando. Vuelva a intentarlo más adelante.",
	OncePerShopper: "Este código ya fue usado. Use otro.",
	ExceedsUsageLimit: "Este código alcanzó el límite de veces que puede usarse.",
	RequiresLoggedInShopper: "Inicie sesión para aplicar este código."
};
var feeMessages = {
	postageFee: "Franqueo",
	mailingServiceFee: "Servicio de lista de distribución",
	rushProcessingFee: "Procesamiento urgente",
	setupFee: "Configuración",
	fallbackFee: "Cuotas adicionales"
};
var esUS = {
	cartItemsCountMessages: cartItemsCountMessages,
	cartLabelMessages: cartLabelMessages,
	miniCartMessages: miniCartMessages,
	errorMessages: errorMessages,
	templateBillingMessages: templateBillingMessages,
	a11yLabels: a11yLabels,
	couponMessages: couponMessages,
	feeMessages: feeMessages
};

var translationResources = {
    'da-dk': daDK,
    'de-at': deDE,
    'de-ch': deDE,
    'de-de': deDE,
    'en-ca': enUS,
    'en-ie': enGB,
    'en-gb': enGB,
    'en-au': enAU,
    'en-nz': enAU,
    'en-sg': enAU,
    'en-in': enUS,
    'en-us': enUS,
    'es-es': esES,
    'es-us': esUS,
    'it-ch': itIT,
    'it-it': itIT,
    'fi-fi': fiFI,
    'fr-be': frFR,
    'fr-ca': frCA,
    'fr-ch': frFR,
    'fr-fr': frFR,
    'nb-no': nbNO,
    'nl-be': nlNL,
    'nl-nl': nlNL,
    'pt-pt': ptPT,
    'sv-se': svSE,
};

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = "/**\n * Do not edit directly\n * Generated on Mon, 28 Jul 2025 02:42:07 GMT\n */\n/*\nYOU SHALL NOT CHANGE THESE CLASS NAMES!\nThey are used by the Bookends library and will break the integration.\n*/\n.cart-count-value {\n  background-color: var(--swan-base-color-blue-400) !important;\n  color: var(--swan-base-color-black) !important;\n  padding: 0px 4px !important;\n  min-width: 20px !important;\n  height: 20px !important;\n  line-height: 20px !important;\n}\n\n.cart-count-value-container {\n  margin-top: -12px;\n  margin-left: 20px;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n@media only screen and (max-width: 767px) {\n  .cart-count-value-container {\n    margin-top: -4px;\n  }\n}\n.cart-item-count {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.cart-item-count-container {\n  display: block;\n  margin-left: inherit;\n}\n\n.cart-item-count-container > * {\n  text-align: left;\n}\n\n.cart-label {\n  margin-left: 8px;\n}";
styleInject(css_248z);

/**
 * An SVG that paints the shopping bag logo representing a cart
 */
// prettier-ignore
const CartIcon = () => (jsxs("svg", Object.assign({ width: "28", height: "29", viewBox: "0 0 28 29", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsxs("g", Object.assign({ clipPath: "url(#clip0)" }, { children: [jsx("path", { d: "M22 8.09863H6V24.7986H22V8.09863Z", stroke: "black", strokeWidth: "1.5", strokeMiterlimit: "10", strokeLinecap: "round", strokeLinejoin: "round" }), jsx("path", { d: "M11.5 10.6002V5.5002C11.5 4.8002 12.1 4.2002 12.8 4.2002H15.4C16.1 4.2002 16.7 4.8002 16.7 5.5002V10.7002", stroke: "black", strokeWidth: "1.5", strokeMiterlimit: "10", strokeLinecap: "round", strokeLinejoin: "round" })] })), jsx("defs", { children: jsx("clipPath", Object.assign({ id: "clip0" }, { children: jsx("rect", { width: "24", height: "24", fill: "white", transform: "translate(2 2.5)" }) })) })] })));

/**
 * If the cart was not successfully fetched, returns null.
 * If the cart has items, renders the number of items in a bubble.
 * If the cart has zero items, renders a hidden message for accessibility.
 */
const ItemCountDisplay = () => {
    const { cartItemCount, cartItemCountFetchFailed } = useCartItemCountContext();
    const [cartItemsCountMessages] = k(['cartItemsCountMessages']);
    if (cartItemCountFetchFailed) {
        return null;
    }
    return (jsx("div", { children: cartItemCount ? (jsx("div", Object.assign({ className: "cart-count-value-container", "data-testid": "cart-count-value-container" }, { children: jsxs(Count, Object.assign({ className: "cart-count-value", "data-testid": "cart-count-value" }, { children: [jsx(VisuallyHidden, { children: cartItemsCountMessages.cartItemsCount }), jsx(Typography, Object.assign({ component: "span" }, { children: cartItemCount }))] })) }))) : (jsx(VisuallyHidden, { children: cartItemsCountMessages.zeroCartItemsCount })) }));
};

/**
 * Renders a visible localized "Cart" label only on large screens.
 * Hides label from screen reader because it is redundant with cart link aria text.
 */
const Label = () => {
    const [messages] = k(['cartLabelMessages']);
    return (jsx("div", Object.assign({ className: "cart-label", "data-testid": "cart-label", "aria-hidden": true }, { children: jsx(Visible, Object.assign({ lg: true, xl: true }, { children: jsx(Typography, Object.assign({ fontSize: "small" }, { children: messages.cartLabel })) })) })));
};

// This file contains tracking event values which were
// previously stored in a json file.
const navigationClicked = {
    name: 'Navigation Clicked',
    data: {
        category: 'Cart Header',
        label: 'Header',
        eventDetail: '',
        navigationDetail: 'cart',
    },
};

/**
 * Tracks navigation to CartUI on mini-cart icon click
 * This is the old tracking function, it will be replaced by flyoutClicked(cartButton) below
 * when mini-cart is fully implemented.
 */
const trackCartNavigation = ({ pageName, pageSection, pageStage, cartUrl = '/c/', debug = false, }) => {
    var _a;
    if (typeof window !== 'undefined') {
        const windowWithTracking = window;
        try {
            (_a = windowWithTracking.tracking) === null || _a === void 0 ? void 0 : _a.track(navigationClicked.name, Object.assign(Object.assign({}, navigationClicked.data), { 
                // Because the SourcePage and CartUrl are variable, window.location and tenatDetails.cartUrl are prepended to the the eventDetail
                eventDetail: `${window.location};${cartUrl};Header;cart;`, pageSection,
                pageStage,
                pageName }));
        }
        catch (err) {
            // handles tracking exceptions silently
            if (debug) {
                console.error('[CartClient] failed to track event', navigationClicked.name, err);
            }
        }
    }
    else if (debug) {
        console.error('[CartClient] `window` undefined, unable to track navigation.');
    }
};

/**
 * Renders the child component (cart icon) inside a wrapper that will
 * redirect the shopper to their cart.
 */
const CartRedirectLink = ({ children }) => {
    const { tenantDetails } = useSessionContext();
    const { pageName, pageStage, pageSection } = useTrackingContext();
    const clickRedirect = useCallback(() => {
        window.top.location.href = tenantDetails.absoluteCartUrl;
    }, [tenantDetails.absoluteCartUrl]);
    const onClickHandler = useCallback((e) => __awaiter(void 0, void 0, void 0, function* () {
        // prevent the link from navigating
        e.preventDefault();
        // Fires Navigation Clicked event
        trackCartNavigation({
            cartUrl: tenantDetails.cartUrl,
            pageName,
            pageStage,
            pageSection,
        });
        clickRedirect();
    }), [clickRedirect, pageName, pageSection, pageStage, tenantDetails.cartUrl]);
    return (jsx(Link, Object.assign({ href: tenantDetails.absoluteCartUrl, onClick: onClickHandler, "data-position": "0", "data-section": "Header", "data-translation": "Cart", skin: "unstyled", "data-testid": "cart-redirect-link", className: "site-header-link" }, { children: children })));
};

/**
 * Renders a cart icon, item count display, and label.
 */
const CartRedirectContainer = () => (jsx("div", Object.assign({ className: "cart-item-count-container", "data-testid": "mini-cart-outer-container" }, { children: jsx("div", Object.assign({ className: "cart-item-count", "data-testid": "mini-cart-container" }, { children: jsx(CartRedirectLink, { children: jsxs(FlexBox, Object.assign({ alignItems: "center" }, { children: [jsx("div", Object.assign({ className: "cart-icon site-header-link-icon site-header-icon-cart", "data-testid": "cart-icon" }, { children: jsx(CartIcon, {}) })), jsx(ItemCountDisplay, {}), jsx(Label, {})] })) }) })) })));

/**
 * Renders the Cart Icon with Redirect link if auth object is not valid.
 * Renders children (CartRedirectContainer), If auth is valid object that exposese the getIdentity
 * and signIn function.
 */
const AuthValidationWrapper = ({ children, fallback: FallbackComponent = Fragment$1, }) => {
    const { auth } = useSessionContext();
    // If the auth library we are passed is undefined, or does not contain the
    // `getCanonicalId`, `getAuthorizationHeader`, `isSignedIn`, or `signIn` functions,
    // then provide a gracefull experience fall back that only includes
    // the Cart Icon with redirect link to Cart.
    if (!auth ||
        !auth.getCanonicalId ||
        !(auth.getAuthorizationHeader || auth.getToken) ||
        !auth.isSignedIn ||
        !auth.signIn) {
        return jsx(FallbackComponent, {});
    }
    // use a fagment here instead of an empty div, so we don't add extra markup
    return jsx(Fragment, { children: children });
};

const CartRedirectContainerFallback = () => (jsx(CartRedirectLink, { children: jsx("div", Object.assign({ className: "cart-item-count-container", "data-testid": "mini-cart-auth-wrapper-container" }, { children: jsx("div", Object.assign({ className: "cart-item-count", "data-testid": "mini-cart-auth-wrapper" }, { children: jsxs(FlexBox, Object.assign({ alignItems: "center" }, { children: [jsx("div", Object.assign({ className: "cart-icon", "data-testid": "cart-icon" }, { children: jsx(CartIcon, {}) })), jsx(Label, {})] })) })) })) }));

/**
 * Primary entry component for the mini cart module.
 * Sets up the session context needed to make session details available to the app.
 */
const MiniCart = (props) => {
    const { locale, tenantDetails, auth, pageName, pageStage, pageSection } = props;
    return (jsx(ScreenClassProvider, { children: jsx(m, Object.assign({ translationResources: translationResources, locale: locale, logLevel: "SILENT" }, { children: jsx(SessionContextProvider, Object.assign({ tenantDetails: tenantDetails, locale: locale, auth: auth }, { children: jsx(ErrorBoundary, Object.assign({ fallback: jsx("div", {}), onError: (err) => {
                        console.error(err);
                    } }, { children: jsx(TrackingContextProvider, Object.assign({ pageName: pageName, pageStage: pageStage, pageSection: pageSection }, { children: jsx(CartItemCountProvider, { children: jsx(AuthValidationWrapper, Object.assign({ fallback: CartRedirectContainerFallback }, { children: jsx(CartRedirectContainer, {}) })) }) })) })) })) })) }));
};

const siteTenantConfigUrl = 'https://site-tenant-configuration.s3.eu-west-1.amazonaws.com';
/**
 * A helper function for clients that leverages the site tenant discoverability system to gather the
 * vital details needed for rendering the mini cart experience.
 *
 * For additional information: https://vistaprint.atlassian.net/wiki/spaces/OMT/pages/775979230/OM+Site+Tenant+Configuration+Framework#Discoverability
 */
const getCartTenantDetails = (brand, locale, environment = 'production') => __awaiter(void 0, void 0, void 0, function* () {
    const siteTenantIndex = (yield u({
        url: `${siteTenantConfigUrl}/index/${environment}/${brand}/${locale}`,
    })
        .then((response) => response.json())
        .then((tenantDetails) => {
        const { tenantId, links: { baseUrl, cart, checkout }, siteHref, } = tenantDetails;
        return {
            tenantId,
            baseUrl,
            cart,
            checkout,
            siteHref,
        };
    }));
    const absoluteCartUrl = new URL(siteTenantIndex.cart, siteTenantIndex.baseUrl)
        .href;
    const absoluteCheckoutUrl = new URL(siteTenantIndex.checkout, siteTenantIndex.baseUrl).href;
    return u({
        url: `${siteTenantConfigUrl}${siteTenantIndex.siteHref}`,
    })
        .then((response) => response.json())
        .then((siteConfig) => {
        var _a;
        return ({
            tenantId: siteTenantIndex.tenantId,
            siteName: siteConfig.siteName,
            cartUrl: siteTenantIndex.cart,
            checkoutUrl: siteTenantIndex.checkout,
            absoluteCartUrl,
            absoluteCheckoutUrl,
            cartCountType: ((_a = siteConfig.miniCartData) === null || _a === void 0 ? void 0 : _a.cartCountType) || 'itemCount',
            absoluteOrderDetailsUrl: new URL(siteConfig.nav.orderDetails, siteTenantIndex.baseUrl).href,
            termsAndConditions: new URL(siteConfig.nav.termsAndConditions, siteTenantIndex.baseUrl).href,
            privacyPolicy: new URL(siteConfig.nav.privacyPolicy, siteTenantIndex.baseUrl).href,
            paymentEnvironment: siteConfig.paymentOptions.paymentEnvironment,
            siteCountry: siteConfig.country,
            allowedBillingCountries: siteConfig.geoData.billing,
            allowedShippingCountries: siteConfig.geoData.shipping,
            language: siteConfig.uiLocalization.language,
            customerCareContact: siteConfig.nav.customerCareContact,
        });
    });
});

export { MiniCart, getCartTenantDetails, invalidateMiniCartData };
//# sourceMappingURL=index.js.map
